import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdateProjectQueries } from "@/queries/query-project";

export const useDeleteProject = (projectId: string, onSuccess: () => void) => {
  const updateProjectQueries = useUpdateProjectQueries();
  return useMutationWithErrorHandler(
    async () => {
      await getRanaApiV1().ProjectsApi.projectDestroy({ projectId });
      updateProjectQueries(projectId, null);
    },
    {
      onSuccess,
    }
  );
};
